import themeUtils from '../themeUtils';

export default class DynamicPromotion {
  constructor(section) {
    this.el = section.el;
    this.adjustHeight = this.adjustHeight.bind(this);
    this._headerOffset = this._headerOffset.bind(this);
    this.header = document.querySelector('[data-section-type="header"]');
    this.parent = this.el.parentElement;
    this.wrapper = this.el.querySelector('[data-promotion-wrapper]');
    this.content = this.el.querySelector('[data-promotion-content]');
    this.image = this.el.querySelector('[data-promotion-image]');
    this.imageContainer = this.el.querySelector('[data-promotion-image-container]');

    this.isFullScreen = section.data.layout === 'full-screen';

    this._bindEvents();
    return this.adjustHeight();
  }

  remove() {
    window.removeEventListener('resize', themeUtils.debounce(this.adjustHeight, 100));
    window.removeEventListener('scroll', themeUtils.debounce(this.adjustHeight, 10));
  }

  onSectionUnload() {
    this.remove();
  }

  onSectionReorder() {
    return this._headerOffset();
  }

  adjustHeight() {
    const heights = [];

    // An image can be shorter than text
    if (this.imageContainer) {
      if (this.content) {
        heights.push(this.content.getBoundingClientRect().height);
      }

      if (this.image) {
        heights.push(this.image.getBoundingClientRect().height);
      }

      const minHeight = Math.max.apply(null, heights);

      this.imageContainer.style.height = `${minHeight}px`;
    }

    return this._headerOffset();
  }

  _bindEvents() {
    window.addEventListener('resize', themeUtils.debounce(this.adjustHeight, 100));
    window.addEventListener('scroll', themeUtils.debounce(this.adjustHeight, 10));
  }

  // Adjust container to compensate for header height if its in viewport
  _headerOffset() {
    let newHeight;
    if (!this.isFullScreen) { return; }

    const headerHeight = this.header.getBoundingClientRect().height;
    const headerScrolledHeight = this.header.querySelector('.navigation').getBoundingClientRect().height;
    const isFirstChild = this.parent.previousElementSibling === null;
    const isStickyEnabled = document.body.classList.contains('sticky-header');
    const maxHeight = window.innerHeight;

    if (themeUtils.isMedium()) {
      this.wrapper.style.height = '';
    }

    // If is first child, always make it full screen minus header height
    if (isFirstChild) {
      newHeight = maxHeight - headerHeight;
      this.wrapper.style.height = `${newHeight}px`;

      // Otherwise, if its larger than tablet, and sticky is enabled, take off nav height
    } if (!themeUtils.isMedium() && isStickyEnabled) {
      newHeight = maxHeight - headerScrolledHeight;
      this.wrapper.style.height = `${newHeight}px`;

      // Is not tablet, and header is not sticky, remove offset
    }

    this.wrapper.style.height = '';
  }
}
